import { BuildingsIconComponent } from 'assets/icons/buildings';
import { EditButton } from '@refinedev/antd';
import { ICompany } from 'interfaces/companies';
import { PageHeader } from 'components/professor_area/PageHeader';
import { ShowLayout } from 'components/layout/layout/ShowLayout';
import { Space, Tabs, Tag } from 'antd';
import { TabCompanyContracts } from './components/TabCompanyContracts';
import { TabCompanyInfo } from './components/TabCompanyInfo';
import { useSearchParams } from 'react-router-dom';
import { useShow } from '@refinedev/core';

export const CompanyShow = () => {
  const { queryResult } = useShow<ICompany>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  const [searchParams, _] = useSearchParams();
  const currentTab = searchParams.get('tab');

  if (!record) {
    return null;
  }

  return (
    <ShowLayout isLoading={isLoading} title="Visualizar unidade">
      <PageHeader
        title={record?.name}
        icon={BuildingsIconComponent}
        meta={
          <Space>
            <Tag>CNPJ: {record?.cnpj}</Tag>
          </Space>
        }
        actions={<EditButton type="primary" />}
      />

      <Tabs defaultActiveKey={currentTab ?? 'info'} className="custom-tabs">
        <Tabs.TabPane tab="Informações Gerais" key="info">
          <TabCompanyInfo company={record} />
        </Tabs.TabPane>

        <Tabs.TabPane tab="Contratos" key="contracts">
          <TabCompanyContracts company={record} />
        </Tabs.TabPane>
      </Tabs>
    </ShowLayout>
  );
};
